import React from "react";
import Modal from "@mui/material/Modal";

const RolesModal = ({
  isModalOpen,
  setIsModalOpen,
  children
}) => {

  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={setIsModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="roles_modal" style={{outline: "none"}}>
          {children}
        </div>
      </Modal>
    </>
  );
};

export default RolesModal;
